module.exports = __webpack_public_path__ + "static/media/level-15-18.fa68a748.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/floorplates/level-15-18.svg
// module id = 578
// module chunks = 0